import { ParsedUrlQuery } from 'querystring';
import { castArray, map } from 'lodash';
import { slugToId, slugToString } from 'lib/utils/filterUtils';
import { JobSearchCriteria, JobSort } from 'lib/types/jobs';

const QUERY_CRITERIA_MAP: { [key: string]: keyof JobSearchCriteria } = {
  role: 'roleIds',
  users: 'accountIds',
};

export function queryToCriteria(query: ParsedUrlQuery) {
  return Object.keys(query).reduce(
    (acc, key) => {
      const criteriaKey = QUERY_CRITERIA_MAP[key] || key;
      const value = query[key];
      if (criteriaKey.includes('Id')) {
        acc[criteriaKey] = map(castArray(value), (q: string) => slugToId(q));
      } else if (criteriaKey === 'near' || criteriaKey === 'geo') {
        acc[key] = slugToString(value as string);
      } else if (criteriaKey === 'list') {
        acc[criteriaKey] = slugToString(value as string);
      } else {
        acc[key] = query[key];
      }
      return acc;
    }, {} as any,
  );
}

export const jobSortOptions: { [K in Exclude<JobSort, 'oldest'>]: string } = {
  startedDate: 'Start Date',
  pay: 'Pay',
  createdAt: 'Date Posted',
};
